import React from 'react';
interface BrandIconProps {
  width?: number;
  height?: number;
}
export const BrandIcon: React.FC<BrandIconProps> = ({
  width = 48,
  height = 48
}) => {
  return <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-223">
      <path d="M8 12C8 9.79086 9.79086 8 12 8H36C38.2091 8 40 9.79086 40 12V36C40 38.2091 38.2091 40 36 40H12C9.79086 40 8 38.2091 8 36V12Z" fill="#0284c7" data-id="element-224" />
      <path d="M8 12C8 9.79086 9.79086 8 12 8H36C38.2091 8 40 9.79086 40 12V36C40 38.2091 38.2091 40 36 40H12C9.79086 40 8 38.2091 8 36V12Z" fill="url(#paint0_linear_electric_blue)" data-id="element-225" />
      <path d="M16 18L16 32" stroke="white" strokeWidth="4" strokeLinecap="round" data-id="element-226" />
      <path d="M24 14L24 32" stroke="white" strokeWidth="4" strokeLinecap="round" data-id="element-227" />
      <path d="M32 22L32 32" stroke="white" strokeWidth="4" strokeLinecap="round" data-id="element-228" />
      <path d="M16 24H32" stroke="white" strokeWidth="2" strokeLinecap="round" data-id="element-229" />
      <defs data-id="element-230">
        <linearGradient id="paint0_linear_electric_blue" x1="8" y1="8" x2="40" y2="40" gradientUnits="userSpaceOnUse" data-id="element-231">
          <stop stopColor="#0ea5e9" data-id="element-232" />
          <stop offset="1" stopColor="#2563eb" data-id="element-233" />
        </linearGradient>
      </defs>
    </svg>;
};